import React, {Component} from 'react';
import { Card, Col,Row } from 'reactstrap'

class LicenseDenied extends Component {
   

  render() {

   
      return (
        <Card className="top-card" >
    
     
        <Row style={{"padding":"0 70px"}}>
        {
          <div>
              <Row className="mt-5">
                <Col md="12" sm="12" xs="12" style={{"color":"#f44336"}}><h5>Access Denied!</h5>
                </Col><br />
              </Row>
              <Row>
                <Col md="12" sm="12" xs="12">
                  <p>
                    {
                      `Your account has not been assigned a license, Please contact 
                      your administrator if you think this is an error.`
                    }
                  </p>
                </Col>
              </Row>
        
        

              
              <hr />
             
             
          </div>
        }
        </Row>
      </Card>
   )
  }
}



export default LicenseDenied;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/LicenseDenied.js